<template>
    <a-card title="菜单包含功能列表">
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
        </div>
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
            <template #url="{text}">
                <div style="white-space: pre-wrap">{{ text }}</div>
            </template>
            <template #enable="{record}">
                <switch-btn :value="record.enable" key-field="enable" :switch-url="editUrl"
                            :checkedValue="0" :uncheckedValue="1"
                            :params="{menuId:record.menuId}"
                            @ok="loadData"/>
            </template>
            <template #action="{record}">
                <div class="table-row-operations">
                    <a @click="onEdit(record)">编辑</a>
                    <a-popconfirm title="确认要删除吗?" @confirm="onDelete(record.key)">
                        <a class="delete">删除</a>
                    </a-popconfirm>
                </div>
            </template>
        </a-table>
    </a-card>
    <MenuListModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
</template>
<script>
import {tableListMixin} from "@/mixins";
import MenuListModal from "./MenuListModal";
import {sys_menu} from "@/api/adminService";
import bus from "@/utils/bus";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "功能编码", dataIndex: "menuCode", key: "menuCode"},
    {title: "功能名称", dataIndex: "menuName", key: "menuName"},
    {title: "请求路径", dataIndex: "url", key: "url", slots: {customRender: "url"}},
    {title: "启用状态", dataIndex: "enable", key: "enable", slots: {customRender: "enable"}},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "MenuList",
    mixins: [tableListMixin],
    components: {
        MenuListModal,
    },
    data() {
        return {
            columns,
            queryParam: {},
            queryParamFixed: {
                parentId: ''
            },
            listUrl: sys_menu.getMethods,
            listKeyField: 'menuId',
            deleteUrl: sys_menu.methodDel,
            editUrl: sys_menu.saveOrUpdate,
            immediateLoadData: false,
        }
    },
    mounted() {
        bus.$on('onMenuSelect', this.onMenuSelect)
    },
    beforeUnmount() {
        bus.$off('onMenuSelect', this.onMenuSelect)
    },
    methods: {
        onMenuSelect(id) {
            this.queryParamFixed.parentId = id;
            this.loadData(1);
        },
        onAdd() {
            this.onShowModal("modal", {
                parentId: this.queryParamFixed.parentId,
                urlType: 2,
            });
        },
        onEdit(record) {
            this.onShowModal("modal", record);
        }
    }
}
</script>
<style scoped lang="less">
.ant-card{
  background-color: #ffffff;
}
</style>
